import OverlayCart from "../../components/pagebuilder/cart/OverlayCart.svelte"
import { newNotification, overlays } from "../../store"
import { addCartItem, createCart } from "../CommerceAPIs/bigCommerce/cart"
import { getCookie, setCookie } from "../utils"

export function showCartOverlay() {
    overlays.update((current) => [...current, { id: "cart", content: OverlayCart, title: "Warenkorb", properties: {} }])
}

export async function addProductToCart(selectedVariant: BKDFProductVariant, quantity = 1) {
    const cartId = getCookie("cartId")

    if (!selectedVariant?.id) {
        newNotification({
            class: "error",
            html: "Missing product variant ID",
        })
        return "Missing product variant ID"
    }

    try {
        if (cartId) {
            await addCartItem(cartId, [
                { merchandiseId: selectedVariant?.id, quantity, productId: selectedVariant.parentId },
            ])

            newNotification({
                class: "success",
                html: "Item added to cart",
            })
            showCartOverlay()
        } else {
            const { id } = await createCart([
                { merchandiseId: selectedVariant?.id, quantity, productId: selectedVariant.parentId },
            ])
            console.log("ID:", id)
            newNotification({
                class: "success",
                html: "Item added to cart",
            })
            if (id) setCookie("cartId", id)
            showCartOverlay()
        }
    } catch (e) {
        newNotification({
            class: "error",
            html: "Error adding item to cart",
        })
        return "Error adding item to cart"
    }
}

function getAllOptionTypes(product: BKDFProduct): OptionNames[] {
    const optionTypes = new Set<OptionNames>()
    for (const variant of product.variants) {
        for (const option of variant.selectedOptions) {
            optionTypes.add(option.name)
        }
    }
    return Array.from(optionTypes)
}

export function checkWheterAllOptionsAreSelected(product: BKDFProduct, selectedOptions: BKDFProductSelectedOption[]) {
    const optionTypes = getAllOptionTypes(product)
    return optionTypes.every((optionType) =>
        selectedOptions.find((selectedOption) => selectedOption.name === optionType)
    )
}

export function getUnselectedOptions(product: BKDFProduct, selectedOptions: BKDFProductSelectedOption[]) {
    const optionTypes = getAllOptionTypes(product)
    return optionTypes.filter(
        (optionType) => !selectedOptions.find((selectedOption) => selectedOption.name === optionType)
    )
}

export function getCurrentVariantGivenSelectedOptions(
    product: BKDFProduct,
    selectedOptions: BKDFProductSelectedOption[]
) {
    return product.variants.find((variant) =>
        variant.selectedOptions.every(
            (selectedOption) =>
                selectedOptions.find((option) => option.name === selectedOption.name)?.value === selectedOption.value
        )
    )
}
export function getCurrentVariant(product: BKDFProduct, selectedOptions: BKDFProductSelectedOption[]) {
    if (checkWheterAllOptionsAreSelected(product, selectedOptions)) {
        // @ts-ignore
        return getCurrentVariantGivenSelectedOptions(product, selectedOptions)
    }
    return null
}

export function getProductVariantsThatDifferInOptions(
    options: string[],
    variants: BKDFProductVariant[]
): BKDFProductVariant[] {
    const result: BKDFProductVariant[] = []
    for (const variant of variants) {
        for (const option of options) {
            const optionValue = variant.selectedOptions.find((selectedOption) => selectedOption.name === option)?.value
            if (
                optionValue &&
                !result.find(
                    (resultVariant) =>
                        resultVariant.selectedOptions.find((selectedOption) => selectedOption.name === option)
                            ?.value === optionValue
                )
            )
                result.push(variant)
        }
    }

    return result.length
        ? result.filter((variant, index, self) => self.findIndex((v) => v.id === variant.id) === index)
        : [variants[0]]
}
export function getProductVariantsThatDifferInOptionsGivenSelectedOption(
    selectedOption: BKDFProductSelectedOption,
    variants: BKDFProductVariant[]
): BKDFProductVariant[] {
    const result: BKDFProductVariant[] = []
    for (const variant of variants) {
        const optionValue = variant.selectedOptions.find((option) => option.name === selectedOption.name)?.value
        if (optionValue && optionValue === selectedOption.value) result.push(variant)
    }
    return result.length
        ? result.filter((variant, index, self) => self.findIndex((v) => v.id === variant.id) === index)
        : []
}

export function mapVariantImages(product: BKDFProduct, variants: BKDFProductVariant[]) {
    const variantImageMappedObject: any = {}
    for (const variant of variants) {
        variantImageMappedObject[variant.id] = product.images.filter((image) => {
            try {
                return (
                    image.altText &&
                    JSON.parse(image.altText).Farbe ===
                        variant.selectedOptions.find((option) => option.name === "Farbe")?.value
                )
            } catch (e) {
                console.log("Error parsing JSON", e, image.altText)
                return false
            }
        })
    }
    return variantImageMappedObject
}
export function getAllSizesForColor(product: BKDFProduct, color: string) {
    const sizes = new Set<string>()
    for (const variant of product.variants) {
        if (
            variant.selectedOptions.find((option) => option.name === "Farbe")?.value === color &&
            variant.selectedOptions.find((option) => option.name === "Größe")?.value
        ) {
            sizes.add(variant.selectedOptions.find((option) => option.name === "Größe")?.value)
        }
    }
    return Array.from(sizes)
}
export const getOptionValues = (product: BKDFProduct, optionName: OptionNames) =>
    product?.options?.find((o) => o?.name === optionName)?.values || []
